<template>
  <TheUncle :color="true" title="삼촌 게시판" description="게시글 목록입니다.">
    <BroadcastUncle title="게시글" :broadcasts="broadcasts" @refresh="refresh" />
  </TheUncle>
</template>
<script>
import TheUncle from "@/components/Uncle/TheUncle";
import Axios from "axios";
import config from "../../config";
import AxiosMiddleware from "../../libs/AxiosMiddleware";
import OPCODE from "../../libs/OPCODE";
import BroadcastUncle from "@/components/Broadcast/BroadcastUncle";

export default {
  name: "uncleQuestion",
  components: { TheUncle, BroadcastUncle },
  mounted() {
    this.refresh();
  },
  methods: {
    async refresh() {
      try {
        this.broadcasts = [];
        const { data } = await Axios.get(
          `${config.hostname}/v1/uncle/broadcast`,
          {
            withCredentials: true
          }
        );

        if (AxiosMiddleware(data.opcode)) {
          switch (data.opcode) {
            case OPCODE.SUCCESS:
              this.broadcasts = data.broadcasts;
              break;
            default:
              config.alert.mixin({
                type: "error",
                title: "1:1 문의 정보를 가져올 수 없습니다."
              });
              break;
          }
        }
      } catch (err) {
        config.alert.mixin({
          type: "error",
          title:
            "1:1 문의 정보를 가져올 수 없습니다.\n인터넷 상태를 확인해주세요."
        });
      }
    }
  },
  data() {
    return {
      broadcasts: []
    };
  }
};
</script>
<style scoped>
.ant-card-body {
  padding: 0px;
}

.ant-collapse-content > .ant-collapse-content-box {
  padding: 2px;
}
</style>
